<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <h3>
          Роль: <b>{{ roleData && roleData.name[$i18n.locale] }}</b>
        </h3>
        <div>
          <b-button
            variant="secondary"
            class="mr-1"
            @click="savePermissionChanges('back')"
          >
            Сброс
          </b-button>
          <b-button variant="primary" @click="savePermissionChanges('save')">
            Сохранить
          </b-button>
        </div>
      </div>
    </b-card>
    <div class="mt-3 w-full pr-4 overflow-scroll custom-scrollbar">
      <ModuleCard
        v-for="item in treeModule"
        :id="roleData.id"
        :module="item"
        :moduleArray="treeModule"
        :expandedModuleId="expandedModuleId"
        @expandedModule="expandedModuleId = $event"
      />
    </div>
  </div>
</template>

<script>
import { BCard, BCardTitle, BButton } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import ModuleCard from './ModuleCard.vue'
export default {
  components: {
    BCard,
    BCardTitle,
    BButton,
    ModuleCard,
  },

  data() {
    return {
      expandedModuleId: null,
      isLoading: false,
      treeModule: [],
      roleData: null,
    }
  },

  computed: {
    ...mapGetters('administration', ['GET_MODULE_LIST']),
  },

  methods: {
    ...mapActions('administration', ['getPermissionModule', 'saveOrReset']),

    async request() {
      try {
        this.isLoading = true
        await this.getPermissionModule(Number(this.roleData.id))
        for (let i = 0; i < this.GET_MODULE_LIST.length; i++) {
          const element = this.GET_MODULE_LIST[i]
          this.treeModule.push(
            element.module.is_child
              ? {
                  ...element,
                  module: { ...element.module, children: [] },
                }
              : element
          )
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.$_errorToast(error.response.data.message || error.message)
      }
    },

    async savePermissionChanges(status) {
      try {
        this.isLoading = true
        await this.saveOrReset({
          id: Number(this.roleData.id),
          status,
        })
        this.treeModule = []
        this.expandedModuleId = null
        this.isLoading = false
        this.request()
      } catch (error) {
        this.isLoading = false
        this.$_errorToast(error.response.data.message || error.message)
      }
    },
  },

  mounted() {
    this.roleData = JSON.parse(this.$route.params.role)
    this.request()
  },
}
</script>

<style lang="scss" scoped>
.custom-scrollbar {
  height: 70vh;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d4d4d4;
    border-radius: 50px;

    &:hover {
      background: #bbbbbb;
    }
  }
}
</style>
